import { LandslideOutlineIcon } from './LandslideOutlineIcon';

/**
 * author: Google
 * id 847329AA-B841-48A2-9700-6363FA219184
 * name landslide-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/landslide-outline.svg
 * tags
 * - Nature 
 */
export const MudslideOutlineIcon = LandslideOutlineIcon;
export default MudslideOutlineIcon